import { store } from 'app/lib/redux'
import { apiCall as _apiCall } from 'core'

export function apiCall(url, options) {
  return _apiCall(url, options, store.getState().general.partnerId)
}
